import { PAYMENT_METHODS } from "@/constants/expenses";
import { z } from "zod";

export const EXPENSE_STATUS = ["Pendiente", "Programado", "Pagado"] as const;

export const createExpenseSchema = z.object({
  expense_date: z.string().min(1, "La fecha es obligatoria"),
  property_id: z.string().min(1, "Debe seleccionar una propiedad"),
  category_id: z.string().min(1, "Debe seleccionar una categoría"),
  subcategory_id: z.string().min(1, "Debe seleccionar una subcategoría"),
  payment_method: z.enum([...PAYMENT_METHODS] as [string, ...string[]], {
    errorMap: () => ({ message: "Debe seleccionar una forma de pago" }),
  }),
  status: z.enum(EXPENSE_STATUS, {
    errorMap: () => ({ message: "Debe seleccionar un estatus" }),
  }),
  amount: z.string()
    .min(1, "El monto es obligatorio")
    .refine((val) => !isNaN(parseFloat(val)) && parseFloat(val) > 0, {
      message: "El monto debe ser mayor a 0",
    }),
  description: z.string().max(70, "La descripción no puede exceder 70 caracteres").optional(),
  tag_id: z.string().optional(),
  receipt_url: z.string().optional(),
});

export type CreateExpenseData = z.infer<typeof createExpenseSchema>;
